<template>
  <div class="action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="720px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-alert
        style="margin-top: -20px;margin-bottom: 10px;"
        title="提示: 以下为帖子内容"
        type="warning"
      >
      </el-alert>
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="帖子内容:" prop="summary">
          <el-input
            v-model="params.summary"
            type="textarea"
            rows="18"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="sendComment()"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";

export default {
  components: {
  },
  data() {
    return {
      dialogVisible: false,
      title: "更新帖子",
      // 提交状态
      flag: false,
      id: "",
      // 回复评论的参数
      params: {
        uid: "",
        level: 2,
        summary: "",
      },
      // 表单验证规则
      rules: {
        summary: [
          { required: true, message: "请输入帖子内容", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    sendComment() {
      const params = Object.assign({}, this.params);
      API.replyContent(params)
        .then((res) => {
          (res.code === 200 &&
            (this.$message.success("帖子内容更新成功！"),
            this.handleClose(),
            this.$emit("handleList"))) ||
            this.$message.error("操作失败，请重试");
        })
        .catch(() => {
          this.$message.error("操作失败，请重试");
        })
        .finally(() => {
          this.params.summary = "";
        });
    },
    // 关闭弹窗
    handleClose() {
      this.params = {
        id: "",
        summary: "",
      };
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.params = {
        id: data.id,
        summary: data.summary,
      };
      this.dialogVisible = true;
    },
  },
};
</script>
